export function sanitizeDashboardProviderCopy(value: string | null | undefined): string {
  if (!value) return '';

  if (/AccessTokenInvalid|Access Token/i.test(value)) {
    return 'Voice calling is temporarily unavailable. Please refresh and try again.';
  }

  return value
    .replace(/\bTwilio rate\b/gi, 'standard carrier rate')
    .replace(/\bTwilio cost\b/gi, 'standard carrier cost')
    .replace(/\bSubmitted to Twilio\s*(?:[-—]\s*)?Under Review\b/gi, 'Submitted for carrier review')
    .replace(/\bSubmitted to Twilio\b/gi, 'Submitted for carrier review')
    .replace(/\bPending Twilio Review\b/gi, 'Pending carrier review')
    .replace(/\bTwilio Review\b/gi, 'Carrier review')
    .replace(/\bTwilio Rejected\b/gi, 'Needs attention')
    .replace(/\bTwilio Bundle\b/gi, 'Compliance bundle')
    .replace(/\bTwilio Console\b/gi, 'provider console')
    .replace(/\bTwilio end-user attributes\b/gi, 'carrier registration details')
    .replace(/\btwilio\b/gi, 'carrier');
}
